export const API_ENDPOINTS = {
    USERS: {
      ALL: '/users/all',
      BASE: '/users',
      CREATE: '/users/create-user',
      GET_USERS: '/users/getUsers',
      STATUS: (userId: string) => `/users/${userId}/status`,
      BY_ID: (userId: string) => `/users/${userId}`,
      TEMP_BY_ID: (userId: string) => `/users/temp_${userId}`,
    },
    USERS_SERVICE_WORKER: {
      ALL: '/api/users/all',
      BASE: '/api/users',
      CREATE: '/api/users/create-user',
      GET_USERS: '/api/users/getUsers',
      STATUS: (userId: string) => `/api/users/${userId}/status`,
      BY_ID: (userId: string) => `/api/users/${userId}`,
      TEMP_BY_ID: (userId: string) => `/api/users/temp_${userId}`,
    },
    AUTH: {
      REFRESH: '/api/auth/refresh',
    },
    ROLES: {
      ALL: '/roles/all',
    },
    ROLES_SERVICE_WORKER: {
      ALL: '/api/roles/all',
    },
    JOBSITES: {
      GET_JOBSITES: '/api/jobsite-management/get-jobsites',
      GET_JOBDETAILS: '/api/jobsite-management/jobdetails/',
      GET_JOBSITE_ADDRESS: '/api/jobsite-management/address/',
      GET_JOBSITE_WORKERS: '/api/jobsite-management/workers/',
      GET_JOBSITE_FILES: '/api/jobsite-management/files/',
      GET_JOBSITE_TRADES: '/api/jobsite-management/trades/',
      GET_JOBSITE: '/api/jobsite-management/get-jobsite/',
      JOBSITE_DETAILS: '/api/jobsite-management/jobsite-details',
      JOBSITE_DETAILS_PATCH: '/api/jobsite-management/jobsite-details',
      JOBSITE_ADDRESS: '/api/jobsite-management/jobsite-address',
      JOBSITE_ADDRESS_PATCH: '/api/jobsite-management/jobsite-address',
      JOBSITE_WORKERS: '/api/jobsite-management/jobsite-workers',
      JOBSITE_WORKERS_PATCH: '/api/jobsite-management/jobsite-workers',
      JOBSITE_FILES: '/api/jobsite-management/jobsite-files',
      JOBSITE_FILES_PATCH: '/api/jobsite-management/update-job-files',
      JOBSITE_TRADES: '/api/jobsite-management/jobsite-trades',
      JOBSITE_TRADES_PATCH: '/api/jobsite-management/jobsite-trades',
      JOBSITE_SUBMIT: '/api/jobsite-management/submit-jobsite',
      JOBSITE_MARK_AS_COMPLETE: '/api/jobsite-management/mark-as-complete',
      JOBSITE_DELETE: '/api/jobsite-management/jobsite-details',
      GET_JOBSITE_LOGS: '/api/jobsite-logs',
    },
    JOBSITE_VISITS: {
      CREATE_VISIT: '/api/jobsite-visits/create-jobvisit',
      CREATE_WORKERS: '/api/jobsite-visits/workers', 
      CREATE_TRADES: '/api/jobsite-visits/jobsite-trades',
      UPLOAD_FILES: '/api/jobsite-visits/jobsite-files',
      GET_LATEST_WORKERS: '/api/jobsite-visits/get-latest-workers-from-jobsite-visits',
      GET_VISIT_BY_ID: '/api/jobsite-visits/get-jobsite-visit'
    },
    LOOKUPS: {
      GET_LOCALS: '/api/lookup/getlocals',
      GET_PROVINCES: '/api/lookup/getProviences',
      GET_TRADES: '/api/lookup/getTrades',
      GET_SECTORS: '/api/lookup/getsectors',
      GET_USERS: '/api/lookup/getUsers',
      GET_FILTERED_ORGANIZERS: '/api/lookup/getFilteredOrganizers',
      GET_INDUSTRIES: '/api/lookup/getIndustries',
      GET_FUNDING_RESIDENCES: '/api/lookup/getFundingRes',
      GET_JOB_COMPLETION_STATUS: '/api/lookup/getJobCompStatus',

    },
    CONTRACTOR: {
      GET_CONTRACTORS: '/api/contractor/getContractors',
      CREATE_CONTRACTOR: '/api/contractor/createContractor',
    },
    BLITZ: {
      SCHEDULE: '/api/blitz-mode/schedule',
      GET_STATUS: '/api/blitz-mode/status',
      ACTIVATE: '/api/blitz-mode/activate',
      DEACTIVATE: '/api/blitz-mode/deactivate',
    },
    COMMENTS: {
      GET_COMMENTS: '/api/comments/getComments',
      CREATE_COMMENT: '/api/comments/create',
    },
    METHODS: {
      GET: 'GET',
      POST: 'POST',
      PUT: 'PUT',
      PATCH: 'PATCH',
      DELETE: 'DELETE',
    },
  } as const;